import React, { FC } from 'react';

import { ScopeSettings } from 'src/components/property-settings/sections/scope-settings/ScopeSettings';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { usePropertySettings } from '../context';

import { useSetProperty } from './utils/useSetProperty';

export const ScopeSectionModule: FC = () => {
	const {
		state: { draft, errors }
	} = usePropertySettings();
	const setProperty = useSetProperty();

	return (
		<ScopeSettings
			property={draft}
			setProperty={setProperty}
			propertyError={errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.SCOPE)}
		/>
	);
};
